module.exports = __webpack_public_path__ + "static/media/award-trophy-star.d64fd7b4.svg";